import { useNavigate } from "react-router-dom";
import { signUpActions } from "@/features/sign-up";
import { logout } from "@/services/auth";
import { appRouterPaths } from "@/services/navigation";
import { useAppDispatch } from "@/services/store";

export const useGoToLogin = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const goToLogin = () => {
    dispatch(logout());
    dispatch(signUpActions.resetSteps());
    navigate(appRouterPaths.logIn);
  };
  return { goToLogin };
};
